import React from 'react';
import styles from './seller.module.css';

const Label = ({ question }) => {
  return <p className={styles.label}>{question}</p>;
};

export default Label;
